import academiesData from '../data/academies.json';

// Get academy translation based on current language
export const getAcademyTranslation = (academyName, currentLanguage) => {
  if (!academyName) return academyName;
  
  // Map language codes to our JSON keys
  const languageMap = {
    'ar': 'ar',
    'fr': 'fr', 
    'en': 'en'
  };
  
  const targetLanguage = languageMap[currentLanguage] || 'ar';
  const translationKey = academyName.trim();
  
  // Check localStorage for new translations first
  const newTranslations = JSON.parse(localStorage.getItem('academyTranslations') || '{}');
  
  if (newTranslations[translationKey]) {
    const translation = newTranslations[translationKey][targetLanguage] || academyName;
    return translation;
  }
  
  // Fallback to static data
  const staticTranslation = academiesData[translationKey];
  if (staticTranslation) {
    const translation = staticTranslation[targetLanguage] || academyName;
    return translation;
  }
  
  // If no translation found, return original name
  return academyName;
};

// Add new academy translation
export const addAcademyTranslation = (academyName, translations) => {
  const newTranslations = JSON.parse(localStorage.getItem('academyTranslations') || '{}');
  const translationKey = academyName.trim();
  
  newTranslations[translationKey] = {
    ar: translations.ar || academyName,
    fr: translations.fr || academyName,
    en: translations.en || academyName
  };
  
  localStorage.setItem('academyTranslations', JSON.stringify(newTranslations));
  
  // Generate JSON for manual file update
  const combinedData = { ...academiesData, ...newTranslations };
  const jsonString = JSON.stringify(combinedData, null, 2);
  
  // Create downloadable file
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'academies.json';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  
  console.log('Academy translations saved to localStorage');
  console.log('Please update src/data/academies.json with the downloaded file');
  
  return {
    success: true,
    data: newTranslations[translationKey],
    message: 'Translation saved successfully'
  };
};

// Reload translations from localStorage
export const reloadTranslations = () => {
  const newTranslations = JSON.parse(localStorage.getItem('academyTranslations') || '{}');
  return { ...academiesData, ...newTranslations };
};

// Validate translations file
export const validateTranslationsFile = (translations) => {
  const errors = [];
  
  Object.keys(translations).forEach(key => {
    const translation = translations[key];
    if (!translation.ar || !translation.fr || !translation.en) {
      errors.push(`Missing translations for ${key}`);
    }
  });
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Save translations to file
export const saveTranslationsToFile = () => {
  try {
    const newTranslations = JSON.parse(localStorage.getItem('academyTranslations') || '{}');
    const combinedData = { ...academiesData, ...newTranslations };
    
    const jsonString = JSON.stringify(combinedData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = 'academies.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return {
      success: true,
      message: 'Translations exported successfully'
    };
  } catch (error) {
    return {
      success: false,
      message: 'Failed to export translations: ' + error.message
    };
  }
};
